export default "__VITE_ASSET__Dqe3X1Ss__"